import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './QueueRedirect.css';

const QueueRedirect = () => {
    const [countdown, setCountdown] = useState(3);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate('/q');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    return (
        <div className="redirect-container">
            <div className="redirect-content">
                <p className="redirect-message">
                    i said the letter <span className="highlight">q</span> dumbass not queue.
                </p>
                <p className="redirect-timer">
                    rerouting to divy.live/q in {countdown}...
                </p>
            </div>
        </div>
    );
};

export default QueueRedirect;
